import { Palette } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const THEMES = [
  { id: "light", label: "Light" },
  { id: "dark", label: "Dark" },
  { id: "felt", label: "Casino Felt" },
  { id: "royal", label: "Royal Blue" },
  { id: "sunset", label: "Sunset" },
];

export function AppHeader({ theme, setTheme }) {
  return (
    <header className="border-b-2 border-foreground sticky top-0 z-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 border-2 border-foreground bg-foreground text-background flex items-center justify-center font-black text-lg">
            ♠
          </div>
          <div>
            <h1 className="font-cabinet font-black text-xl sm:text-2xl tracking-tighter leading-none">
              CARD COUNTER
            </h1>
            <p className="text-[0.65rem] uppercase tracking-[0.2em] text-muted-foreground">
              Shoe Tracker
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <Palette className="w-4 h-4 text-muted-foreground hidden sm:block" aria-hidden="true" />
          <Select value={theme} onValueChange={setTheme}>
            <SelectTrigger
              className="w-[150px] border-2 border-foreground rounded-none font-mono font-bold bg-card"
              data-testid="theme-select"
              aria-label="Table theme"
            >
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="border-2 border-foreground rounded-none bg-popover">
              {THEMES.map((t) => (
                <SelectItem key={t.id} value={t.id} data-testid={`theme-option-${t.id}`}>
                  {t.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
    </header>
  );
}
